
import { Grid, Hidden} from "@mui/material";
import { GadgetFilter } from "./components/gadgets/GadgetFilter";
import GadgetsGridDisplay from "./components/gadgets/GadgetsGridDisplay";
import { DontHaveGarudaAccountButton } from "./components/DontHaveGarudaAccountButton";
import { useEffect, useState } from "react";
import styles from "./Home.module.css";
import { SearchBar } from "../../components/SearchBar";
import { Carousel } from "../../components/Carousel/Carousel";
import { GadgetPlaform } from "./components/gadgets/GadgetPlaform";
import { GadgetSortColumns, GadgetSortInitialValue, getGadgetSortFieldsByLabel } from "./components/gadgets/GadgetModel";
import { Sorter } from "./components/gadgets/Sorter";
import { IntroCard } from "./components/IntroCard";
import AboutGarudaPlatform from "./components/AboutGarudaPlatform";
import AboutGarudaRecipe from "./components/AboutGarudaRecipeCard";
import { useAppSelector } from "../../common/state/hooks";
import { GarudaIntroductionText } from "./components/GarudaIntroductionText";
import { useMediaQuery } from "@mui/material";
import { useLocation, useParams } from "react-router-dom";

const Home = () => {
  const isMobile = useMediaQuery("(max-width:850px)");
  const location = useLocation();
  const isAuthenticated = useAppSelector((state) => state.auth.authenticated);
  const { platform = GadgetPlaform.WINDOWS } = useParams();
  const [sortBy, setSortBy] = useState<GadgetSortColumns>(GadgetSortInitialValue[0]);
  const query = new URLSearchParams(location.search);
  const gName = query.get('name') || "";
  const [gadgetName, setGadgetName] = useState<string>(gName);
  const [currentPage, setCurrentPage] = useState<number>(0);
  const carouselCards: React.ReactElement[] = [
      <IntroCard key={"inro-card"}/>,
      <AboutGarudaPlatform key={"about-garuda-platform"}/>,
      <AboutGarudaRecipe key={"about-garuda-recipe"}/>
  ];
  if(isMobile) {
    carouselCards.splice(0, 1);
  }


  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const sortBy = query.get('sort_by') || GadgetSortInitialValue[0].label;
    const gName = query.get('name') || "";
    const temp = getGadgetSortFieldsByLabel(sortBy) || GadgetSortInitialValue[0];
    const pageNo = parseInt(query.get('page_no') || "0");
    setCurrentPage(pageNo);
    setSortBy(temp);
    setGadgetName(gName);
}, [location]);

  return (
    <>
      <Carousel cards={carouselCards}/>
      <GarudaIntroductionText />
      <div className={styles.container}>
        <Hidden mdDown>
          <Grid container>
            <Grid item xs={12} md={7} lg={7} className={styles.searchBar}>
              <SearchBar />
            </Grid>
            <Grid item xs={12} md={5} lg={5}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={7} lg={7}>
                  <Sorter sortBy={sortBy}/>
                </Grid>
                <Grid item xs={12} md={5} lg={5}>
                  <GadgetFilter platform={platform as GadgetPlaform} />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <GadgetsGridDisplay
            plaform={platform as GadgetPlaform}
            gadgetName={gadgetName}
            sortModel={sortBy}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        </Hidden>
        {
          !isAuthenticated && <Hidden mdDown><DontHaveGarudaAccountButton /></Hidden>
        }
    </div>
    </>
  );
};

export default Home;
